var _path, _path2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVisaSelect(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 24,
    viewBox: "0 0 34 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 4C0 1.79086 1.79086 0 4 0H30C32.2091 0 34 1.79086 34 4V20C34 22.2091 32.2091 24 30 24H4C1.79086 24 0 22.2091 0 20V4Z",
    fill: "url(#paint0_linear_5910_90054)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4377 10.5797C17.4232 11.7847 18.4599 12.4573 19.2409 12.8571C20.0434 13.2674 20.3129 13.5304 20.3099 13.8973C20.3037 14.4588 19.6697 14.7065 19.0763 14.7162C18.0411 14.7331 17.4392 14.4226 16.9607 14.1877L16.5878 16.021C17.0679 16.2535 17.9569 16.4562 18.8788 16.4651C21.0426 16.4651 22.4584 15.3429 22.4661 13.6028C22.4745 11.3946 19.5587 11.2723 19.5786 10.2852C19.5855 9.98597 19.8573 9.6666 20.4531 9.58535C20.7478 9.54432 21.5618 9.51294 22.4845 9.95942L22.8466 8.18559C22.3505 7.99573 21.7126 7.81393 20.9186 7.81393C18.8818 7.81393 17.4492 8.95143 17.4377 10.5797ZM26.3268 7.96677C25.9317 7.96677 25.5986 8.20892 25.45 8.58058L22.3589 16.3348H24.5212L24.9516 15.0854H27.594L27.8436 16.3348H29.7495L28.0863 7.96677H26.3268ZM26.6292 10.2273L27.2533 13.3695H25.5442L26.6292 10.2273ZM14.8159 7.96677L13.1115 16.3348H15.172L16.8757 7.96677H14.8159ZM11.7677 7.96677L9.62294 13.6623L8.7554 8.8195C8.65356 8.2789 8.25157 7.96677 7.80516 7.96677H4.29901L4.25 8.20972C4.96976 8.37383 5.78753 8.6385 6.28294 8.92167C6.58616 9.09463 6.67269 9.24586 6.77223 9.65694L8.41543 16.3348H10.5931L13.9316 7.96677H11.7677Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5910_90054",
    x1: 15.2734,
    y1: 24,
    x2: 22.9566,
    y2: 0.739194,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#222357"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#254AA5"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisaSelect);
export default __webpack_public_path__ + "static/media/Visa-Select.bacc0792822b51bffe93fd5ef54819e0.svg";
export { ForwardRef as ReactComponent };